import { Box } from "@chakra-ui/react";
import { asHTML } from "@prismicio/client";

const GREEN = "#5A8A1A";

/**
 * Shared "call_out" repeatable-field styling — used identically by BodycontentSlice
 * and ColumsSlice (same field shape: `call_out_text` + `call_out_type`, "Green" or
 * "Warning"). `call_out_text` can be a plain string (Bodycontent's field type) or a
 * Prismic rich-text array (Colums' field type) — `isRichText` picks which render path.
 */
export default function CalloutBox({ callOut, isRichText }) {
  if (!callOut?.call_out_text) return null;
  const calloutType = callOut.call_out_type?.toLowerCase();

  return (
    <Box
      borderLeftWidth="4px"
      borderLeftColor={calloutType === "warning" ? "orange.400" : GREEN}
      bg={calloutType === "warning" ? "orange.50" : `${GREEN}1A`}
      borderRadius="md"
      p={4}
      mt={4}
      color="gray.800"
      fontWeight="500"
    >
      {isRichText ? (
        <Box sx={{ p: { m: 0 } }} dangerouslySetInnerHTML={{ __html: asHTML(callOut.call_out_text) }} />
      ) : (
        callOut.call_out_text
      )}
    </Box>
  );
}
